import * as deDe from './de-DE';
import * as enUs from './en-US';
import * as heIl from './he-IL';
import * as ruRu from './ru-RU';

export const adaptTranslations = (key: string, suffix: string) => {
  const msg = key.toLowerCase();
  return key.match(new RegExp(suffix)) ? msg : `${suffix}.${msg}`;
};

export const messages = {
  'en-US': { translation: enUs.default },
  'ru-RU': { translation: ruRu.default },
  'he-IL': { translation: heIl.default },
  'de-DE': { translation: deDe.default },
};
